import {useListView} from './core/ListViewProvider'
import {IndemnityAreaTable} from './table/IndemnityAreaTable'
import {KTCard, KTSVG} from '../../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {useState} from 'react'
import {ModalAddIdemminityArea} from '../formIndemnityItemsAdd/ModalAddIdemminityArea'

const IndemnityAreaList = () => {
  const {itemIdForUpdate} = useListView()
  const intl = useIntl()
  const [showIndenityAreaModal, setIndenityAreaModal] = useState<boolean>(false)
  let {uuid} = useParams()
  uuid?.toString()

  return (
    <>
      <div className='py-3'>
        <KTCard>
          <div className='d-flex justify-content-between p-10 pb-0'>
            <h5>{intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.TITLE'})}</h5>
            <button
              className='d-flex align-items-center btn btn-sm btn-primary px-2 pe-5'
              onClick={() => setIndenityAreaModal(true)}
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_participations'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              {intl.formatMessage({id: 'COMMON.INSERT'})}
            </button>
            <ModalAddIdemminityArea
              id='idemminityArea'
              show={showIndenityAreaModal}
              handleClose={() => setIndenityAreaModal(false)}
              property_uuid={uuid || ''}
            />
          </div>

          <IndemnityAreaTable />
        </KTCard>
      </div>
      {itemIdForUpdate !== undefined}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const IndemnityAreaListWrapper = () => <IndemnityAreaList />

export {IndemnityAreaListWrapper}
